/**
 * BrandLogo — canonical "Action!" title with gold shimmer gradient.
 * Pure presentational. No click handlers, no navigation.
 * Wrap in a heading/div for sizing; this component only handles the visual style.
 */
export default function BrandLogo({ className = '' }) {
  return (
    <span className={`brand-logo${className ? ' ' + className : ''}`}>Action!</span>
  )
}
